<div class="container">
  <div class="footer-epg" *ngIf="displayEPG">
    <!-- Channel Info -->
    <div *ngIf="arrowChannelUp" class="arrow-up">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
      </svg>
    </div>
    <div *ngIf="arrowChannelDown" class="arrow-down">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
      </svg>
    </div>
    <div *ngIf="currentChannel" class="logo-channel d-flex align-items-center justify-content-center">
      <img class="rounded d-block" [src]="currentChannel.Logo?.PublicUrl" alt="">
    </div>
    <!-- EPG -->
    <div class="grid-channels">
      <!-- Each Program -->
      <ng-container *ngFor="let uiProgram of visiblePrograms; let i = index">
        <div *ngIf="arrowProgramLeft" class="arrow-left">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
          </svg>
        </div>
        <div [ngClass]="{'selected': visibleProgramIndex === i}" class="schedule">
          <div [ngStyle]="{'visibility':(showTooltip && visibleProgramIndex === i)?'visible':'hidden'}" [ngClass]="{'tooltip-left': visibleProgramIndex === 0,'tooltip-center': visibleProgramIndex === 1}" class="tooltipEPG d-flex justify-content-around">
            <div class="tooltip-img">
              <img class="rounded d-block" [src]="uiProgram.program.ThumbnailUrl" alt="">
            </div>
            <div class="tooltip-description" [innerHTML]="uiProgram.program.Description"></div>
          </div>
          <div class="actions-info d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div class="dot-red">
              </div>
              <div class="bnt-info">INFO</div>
            </div>
          </div>
          <div class="schedules-info">
            <div class="title-epg" [innerHTML]="uiProgram.program.Title"></div>
            <div class="row align-items-center mt-1">
              <div style="width: 200px;">
                <div class="time-epg">{{uiProgram.program.StartTime | date : 'shortTime' : '' : 'pt-BR'}} - {{
                  uiProgram.program.EndTime | date : 'shortTime' : '' : 'pt-BR' }}</div>
                <div class="progress" *ngIf="uiProgram.isLive">
                  <div class="progress-bar bg-danger" role="progressbar" [style.width.%]=progress aria-valuenow="100"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
              <div *ngIf="uiProgram.isLive" class="noar d-flex align-items-center justify-content-evenly">
                <div>NO AR</div>
                <svg height="10" width="10">
                  <circle cx="5" cy="5" r="5" stroke-width="3" fill="white" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="arrowProgramRight" class="arrow-right">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
          </svg>
        </div>
      </ng-container>
    </div>
  </div>
</div>
